import { ChangeDetectorRef, Component, ViewChild, ViewContainerRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { plainToInstance } from 'class-transformer';
import { TranslateFormatText } from '../../../helpers/array.helpers';
import { CapsuleHelper } from '../../../helpers/capsule.helper';
import { NotificationHelper } from '../../../helpers/notification.helper';
import { MEDIA_TYPE_DICT, MediaSource } from '../../../models/datamodel/mediasource.model';
import { TranslatedString } from '../../../models/translatedstring.model';
import { MediaService } from '../../../services/media.service';
import { BaseListDetail, BaseListSettings, DeleteTexts, SaveTexts } from '../../base.list.settings';

@Component({
    selector: 'mediasource-settings',
    templateUrl: '../../base.list.settings.html'
})
export class MediaSourceSettings extends BaseListSettings {
    IsCapsuleInstance = false;

    static GetSettingsEntry() {
        return {
            Caption: '@@Medienquellen',
            ID: 'mediasources',
            Icon: 'image2',
            Index: 3,
            Parent: 'data',
            Security: {
                Name: 'evidanza.App.Shared.Security.DataRight',
                Value: 256
            },
            Content: MediaSourceSettings
        };
    }

    constructor(private translate: TranslateService, private service: MediaService, protected cdRef: ChangeDetectorRef) {
        super(cdRef);
    }

    getContentType() {
        return MediaSourceDetail;
    }

    protected init() {
        CapsuleHelper.GetCapsuleTags().then(r => {
            if (r) {
                this.IsCapsuleInstance = true;
            }
        });
    }

    loadList(handler) {
        this.service.Get().subscribe(sources => {
            const list = [];
            sources.forEach(function (source) {
                list.push({
                    Caption: source.Caption,
                    ID: source.SID,
                    IsCapsule: source.IsCapsule,
                    IsOverridden: source.IsOverridden
                });
            });
            handler(list);
        });
    }

    loadData(data) {
        this.service.GetMediaSource(data).subscribe(source => {
            let ms;
            ms = plainToInstance(MediaSource, source);
            const edit = ms && ms.NonEditable !== true;
            this.ShowDelete = edit;
            this.ShowSave = edit || this.IsCapsuleInstance;
            this.setSelectedItem(ms);
            this.Component.IsCapsuleInstance = this.IsCapsuleInstance;
        });
    }

    getNewItem() {
        this.ShowDelete = true;
        this.ShowSave = true;
        const ds = new MediaSource();
        const name = 'DataSource_';
        let length = 1;
        if (this.ListItems.length > 0) {
            length = this.ListItems.length;
        }
        ds.Name = name + length;
        ds.Caption = new TranslatedString(this.translate.instant('@@Neue Medienquelle'));
        return ds;
    }

    getDeleteText(sel): DeleteTexts {
        const retVal = new DeleteTexts();
        retVal.Question = new TranslateFormatText('@@Sind Sie sicher, dass Sie die Medienquelle \'{0}\' loeschen moechten?');
        retVal.Question.FormatParams.push(sel.Caption);
        retVal.Success = new TranslateFormatText('@@Medienquelle \'{0}\' erfolgreich geloescht.');
        retVal.Success.FormatParams.push(sel.Caption);
        retVal.Title = new TranslateFormatText('@@Medienquelle loeschen');
        return retVal;
    }

    getSaveSuccessText(sel): SaveTexts {
        let caption = TranslatedString.GetTranslation(sel.Caption);
        if (!caption) {
            caption = sel.Name;
        }
        const retVal = new SaveTexts();
        retVal.Text = new TranslateFormatText('@@Medienquelle \'{0}\' erfolgreich gespeichert.');
        retVal.Text.FormatParams.push(caption);
        retVal.Title = new TranslateFormatText('@@Medienquelle speichern');
        return retVal;
    }

    delete(data, handler) {
        this.service.Delete(data).subscribe((res) => {
            handler(res);
        });
    }

    saveInternal(item, handler) {
        this.service.Save(item).subscribe(result => {
            if (result) {
                handler(result, result.SID, result.Caption);
            }
        });
    }

    handleNew(item, result) {
        if (!item.SID) {
            item.SID = result.SID;
        }
        if (!item.Version) {
            item.Version = result.Version;
        }
    }

    updateListItem(item, result) {
        item.IsCapsule = result.IsCapsule;
        item.IsOverridden = result.IsOverridden;
    }
}

@Component({
    selector: 'mediasource-detail',
    templateUrl: './mediasource.settings.html',
    styleUrls: ['./mediasource.settings.css']
})
export class MediaSourceDetail extends BaseListDetail {
    IsCapsuleInstance;
    Clients = [];
    Subscription;
    SelectedMediaType;

    @ViewChild('dynamic', { read: ViewContainerRef }) viewContainerRef: ViewContainerRef;

    constructor(private service: MediaService) {
        super();
    }

    setSelectedItem(item) {
        super.setSelectedItem(item);
        this.SetData();
    }

    ngOnInit() {
        this.service.GetMediaClientTypes().subscribe(clients => {
            this.Clients = clients;
            this.SetData();
        });
    }

    SetData() {
        if (this.Clients) {
            if (this.SelectedItem) {
                if (!this.SelectedItem.ClientType || this.SelectedItem.ClientType == '00000000-0000-0000-0000-000000000000') {
                    this.SelectedItem.ClientType = '4eb395d4-5b74-47de-9951-ee308b1724d8';
                }
                this.SelectedMediaType = this.SelectedItem.ClientType;
            }
            this.OnMediaChanged(true);
        }
    }

    OnMediaChanged(internal) {
        if (this.Subscription) {
            this.Subscription.unsubscribe();
        }
        if (this.viewContainerRef) {
            this.viewContainerRef.clear();
            if (this.SelectedMediaType) {
                this.SelectedItem.ClientType = this.SelectedMediaType;
                var type = MEDIA_TYPE_DICT.get(this.SelectedMediaType);
                if (type) {
                    const comp = this.viewContainerRef.createComponent(type.ControlType);
                    const component: any = comp.instance;
                    if (component) {
                        component.MediaSource = this.SelectedItem;
                        this.Subscription = component.OnDataChange.subscribe(() => { this.OnItemChanged(); });
                    }
                }
            }
        }
        if (!internal) {
            this.OnItemChanged();
        }
    }

    checkConnection() {
        this.service.CheckConnection(this.SelectedItem).subscribe(x => {
            if (x.Successfull) {
                NotificationHelper.Success('@@Successfully connected', '@@Success');
            } else {
                NotificationHelper.Error(x.Error, '@@Error');
            }
        });
    }

    Initialize(InitArgs) {
        if (InitArgs) {
            this.SelectedItem = InitArgs.Data;
        }
    }
}
